import { Zap } from "lucide-react";

/**
 * Badge % réduction
 * - soft : fiche produit
 * - flash : cartes liste (coin haut-gauche)
 */
const DiscountBadge = ({ percent, className = "", variant = "soft" }) => {
  const value = Number(percent);
  if (!Number.isFinite(value) || value <= 0) return null;

  if (variant === "flash") {
    return (
      <span
        className={`inline-flex items-center gap-0.5 bg-[#FF5722] text-white text-[10px] font-normal pl-1.5 pr-2 py-1 rounded-none rounded-br-lg leading-none shadow-md align-top ${className}`}
      >
        <Zap size={11} fill="currentColor" strokeWidth={0} aria-hidden />
        -{Math.round(value)}%
      </span>
    );
  }

  return (
    <span
      className={`inline-flex items-center text-[#FD384F] bg-[#FFF1F0] text-xs font-bold px-1.5 py-0.5 rounded-sm leading-none ${className}`}
    >
      -{Math.round(value)}%
    </span>
  );
};

/**
 * Badge collé au coin du conteneur relative parent (top/left 0, sans marge).
 */
export const DiscountBadgePlacement = ({
  percent,
  className = "",
  badgeClassName = "",
}) => {
  const value = Number(percent);
  if (!Number.isFinite(value) || value <= 0) return null;

  return (
    <div
      className={`absolute top-0 left-0 z-20 m-0 p-0 leading-none pointer-events-none ${className}`}
    >
      <DiscountBadge percent={value} variant="flash" className={badgeClassName} />
    </div>
  );
};

export default DiscountBadge;
